import { apiUtils } from '../utils/apiUtils'

export default {
  get: function (enrollid) {
    return fetch(apiUtils.integration + '/settings/' + enrollid)
      .then(res => res.json())
  },
  save: function (enrollid, clientid, cityname, latitude, longitude) {
    return fetch(apiUtils.integration + '/settings/' + enrollid, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ clientid: clientid != null ? String(clientid) : null, cityname, latitude, longitude }),
    })
  },
}
